export const team = [
    {
        name: "Dylan Hammer",
        photo: "images/headshot.png",
        title: "Backend/Data Management Developer",
        bio:
          `<p>A fresh engineer out of General Assembly's Software Engineering Immersive Bootcamp. He has a passion for backend and data management. <br/><br/>While he may not have a traditional Software Engineering background, he does have 10+ years of real life and  professional work experience that has instilled in him an acute level of drive, dedication, and motivation. He works hard, learns fast, and is always eager to develop new skills.</p>`,
        social: {
          linkedin: "https://www.linkedin.com/in/dylanshammer/",
          github: "https://github.com/HammerNTime",
          email: "hammer.dylan@gmail.com"
        }
    },
    {
        name: "Junior Adessu",
        photo: "images/headshot2.jpg",
        title: "Developer",
        bio:
          "<p>A graphic designer turned Software Engineer, Junior is passionate about the web and contributing to it. While most excited about his front end skills, Junior does have the necessary back end skills to dive deep into the code.</p><p>Formerly in his Graphic Designer role, Junior' successes have stemmed from essential skills, including exceptional creativity, attention to details,  and an understanding of the latest trends in the tech environment. Through General Assembly's Engineering program, he has enhanced his problem-solving abilities and cultivated a reputation as a major contributor through innovation and management. </p>Junior is a collaborative team player who is always searching for opportunities to impart valuable insights. With these qualities, he is able to facilitate positive change and impacting outcomes.<p></p>",
        social: {
          linkedin: "https://www.linkedin.com/in/junioradessu/",
          github: "https://github.com/Jadessu",
          email: "mailto:juniorthedeveloper@gmail.com"
        }
      }

]